<template>
  <!-- Popover container -->
  <div
    v-if="isVisible"
    class="fixed z-50 w-64 p-2 text-sm bg-white border border-solid rounded-lg shadow-md user-info border-neutral-300"
    :style="{ top: `${y}px`, left: `${x}px` }"
  >
    <!-- User name -->
    <h3 class="font-bold">
      {{ user.first_name + " " + user.last_name }}
    </h3>
    <!-- User email -->
    <p>Email: {{ user.email }}</p>
    <!-- User phone number -->
    <p>Telefon: {{ user.phone_number || "Ikke angivet" }}</p>
  </div>
</template>

<script setup>
import { ref, watch, defineProps, onMounted, onUnmounted } from "vue";

// Define component props
const props = defineProps({
  user: {
    type: Object,
    required: true,
  },
  initialX: {
    type: Number,
    required: true,
  },
  initialY: {
    type: Number,
    required: true,
  },
  isVisible: {
    type: Boolean,
    required: true,
  },
});

// Reactive variables for popover position
const x = ref(props.initialX);
const y = ref(props.initialY);

// Function to update popover position based on mouse event
function updatePosition(event) {
  const popover = document.querySelector(".user-info");
  if (!popover) return;

  const popoverWidth = popover.offsetWidth;
  const popoverHeight = popover.offsetHeight;
  const headerHeight = 80; // Approximate height of the fixed header

  let newX = event.clientX + window.scrollX + 10;
  let newY = event.clientY + window.scrollY - popoverHeight - 10;

  // Ensure the popover doesn't go off-screen
  if (newX + popoverWidth > window.innerWidth) {
    newX = window.innerWidth - popoverWidth - 10;
  }
  if (newY < headerHeight) {
    newY = event.clientY + window.scrollY + 10;
  }

  x.value = newX;
  y.value = newY;
}

// Function to handle window resize event
function handleResize() {
  const event = {
    clientX: x.value - window.scrollX,
    clientY: y.value - window.scrollY,
  };
  updatePosition(event);
}

// Lifecycle hook to add event listeners on mount
onMounted(() => {
  if (props.isVisible) {
    window.addEventListener("mousemove", updatePosition);
    window.addEventListener("resize", handleResize);
  }
});

// Lifecycle hook to remove event listeners on unmount
onUnmounted(() => {
  window.removeEventListener("mousemove", updatePosition);
  window.removeEventListener("resize", handleResize);
});

// Watcher to reset position when visibility changes
watch(
  () => props.isVisible,
  (newValue) => {
    if (newValue) {
      x.value = props.initialX;
      y.value = props.initialY;
    }
  }
);

// Watcher to add/remove event listeners based on visibility
watch(
  () => props.isVisible,
  (newValue) => {
    if (newValue) {
      window.addEventListener("mousemove", updatePosition);
      window.addEventListener("resize", handleResize);
    } else {
      window.removeEventListener("mousemove", updatePosition);
      window.removeEventListener("resize", handleResize);
    }
  }
);
</script>
